export default "__VITE_ASSET__CoIVt1N5__"